import sendToServer from './send-to-server';
import trackEvent from './track-event';

const KeyTerms = {
  init() {
    this.identifyKeyTerms($('.question-box'));
    $('.word-adder').click(this.handleTermAddClick.bind(this));
    $('.definition-closer').click(this.handleTermCloseClick.bind(this));
    $('.key-term').click(this.handleTermClick.bind(this));
  },

  setupKeyTermsIn($element) {
    this.identifyKeyTerms($element);
    $element.find('.key-term').click(this.handleTermClick.bind(this));
    $element.find('.word-adder').click(this.handleTermAddClick.bind(this));
    $element.find('.definition-closer').click(this.handleTermCloseClick.bind(this));
  },

  identifyKeyTerms($element) {
    let keyTermHash = $('.question').data('key-terms');
    for (var term in keyTermHash) {
      // Look for the term as a complete word
      // (that may be pluralised - using a very simple pluralisation check)
      let regExp = new RegExp('\\b' + term + 's{0,1}\\b', 'i');
      let newHtml = $element.html().replace(regExp, (matchedTerm) => {
        let termData = keyTermHash[term.toLowerCase()];
        // Single quotes are very important here, because we might be inside a data-explanation="..."
        let expandedTerm =  "<span class='key-term'>" +
          matchedTerm +
          "<span class='key-term-definition neutral-background'>" +
           termData.definition +
           '<br>';
        if (!termData.added) {
          expandedTerm += ("<button class='button white-button word-adder' data-term-id='" +
                      termData.id +
                      "'>Add</button>");
        }
        expandedTerm += ("<span class='definition-closer'>close</span>");
        expandedTerm += "</span></span>";
        return expandedTerm;
      });

      $element.html(newHtml);
    }

  },

  handleTermClick(event) {
    event.stopPropagation();
    if ($(event.target).hasClass('key-term')) {
      $(event.target).find('.key-term-definition').show();
      sendToServer('/api/v2/events',
                   { event: 'viewed_key_term_definition',
                     career_id: $('.question').data('career-id'),
                     question_id: $('.question').data('question-id'),
                     value: $(event.target).find('.word-adder').data('term-id') });
    } else if ($(event.target).hasClass('key-term-definition')) {
      $(event.target).hide();
    }
  },

  handleTermAddClick(event) {
    let $addButton = $(event.target);
    trackEvent('Key Term', 'added', $addButton.data("term-id"));
    sendToServer('/api/v2/saved_key_terms',
              { key_term_id: $addButton.data("term-id") },
              this.brieflyShowWordBankAddConfirmation);
    $addButton.hide();
    $addButton.closest('.key-term-definition').fadeOut();
  },

  handleTermCloseClick() {
    $('.key-term-definition').hide();
  },

  brieflyShowWordBankAddConfirmation() {
    window.setTimeout(()=>{ $('.word-bank-success-message').fadeOut() }, 3000)
    $('.word-bank-success-message').fadeIn();
  }
};

export default KeyTerms;
